import { calculateDocumentTotals, DEFAULT_INVOICE_DISCOUNT_TAX_MODE } from './documentTotals.js';
/**
 * Estimate order discount is stored as a 0–1 fraction (0.10 = 10%).
 * Whole percents from the builder (10 = 10%) are converted so API recompute
 * does not treat 10 as 1000% (clamped to 100% off).
 */
export function normalizeOrderDiscountFraction(value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0)
        return 0;
    const fraction = n > 1 ? n / 100 : n;
    return Math.min(fraction, 1);
}
export function computeEstimatePricing(items, taxRate, options) {
    const orderMarkup = options?.orderMarkupPercent ?? 0;
    const orderDiscount = normalizeOrderDiscountFraction(options?.orderDiscountPercent ?? 0);
    const mode = options?.invoiceDiscountTaxMode ?? DEFAULT_INVOICE_DISCOUNT_TAX_MODE;
    const markupFactor = 1 + orderMarkup;
    const lines = items.map((it) => ({
        quantity: it.quantity,
        unitPrice: it.unitPrice * markupFactor,
        isTaxable: it.isTaxable !== false,
        isManufacturerDiscount: it.isManufacturerDiscount,
    }));
    const totals = calculateDocumentTotals({
        lines,
        taxRateDecimal: taxRate,
        discountType: orderDiscount > 0 ? 'percentage' : 'none',
        discountRate: orderDiscount > 0 ? orderDiscount * 100 : undefined,
        mode,
    });
    // Match legacy estimate fields: subtotal = post-discount, pre-tax (same as total - tax)
    const postDiscountPreTax = round2(totals.total - totals.taxAmount);
    return {
        option1: {
            subtotal: postDiscountPreTax,
            taxAmount: totals.taxAmount,
            total: totals.total,
        },
    };
}
function round2(n) {
    return Math.round(n * 100) / 100;
}
//# sourceMappingURL=pricing.js.map